import reactUpdate from 'immutability-helper';

import {getColumnIndices} from 'notebook/integrations/chemistry/reaction-scheme/StoichiometryTableHelpers';
import {BaseTypedValueType} from 'notebook/tables/TableConstants';

import {StoichiometryStructuredTable} from './StoichiometryStructuredTableAdapter';

/**
 * Produces an updated stoichiometry table where all rows matching `canonicalSmiles`
 * have their compound cell converted from a STRING typed value to a BIOENTITY typed
 * value referencing the newly created molecule. Row metadata (including canonicalSmiles)
 * is preserved.
 *
 * Returns null if no rows match.
 */
export default function updateStoichiometryTableWithCreatedMolecule(
  structuredTable: StoichiometryStructuredTable,
  canonicalSmiles: string,
  moleculeId: string,
  moleculeName: string
): StoichiometryStructuredTable | null {
  const matchingRowIndices = structuredTable.rows.reduce<Array<number>>((acc, row, idx) => {
    if (row.metadata?.canonicalSmiles === canonicalSmiles) {
      acc.push(idx);
    }
    return acc;
  }, []);

  if (matchingRowIndices.length === 0) {
    return null;
  }

  const {compoundColumnIndex} = getColumnIndices(structuredTable.columns);

  const rowsUpdateSpec: Record<number, object> = {};
  for (const rowIndex of matchingRowIndices) {
    rowsUpdateSpec[rowIndex] = {
      cells: {
        [compoundColumnIndex]: {
          text: {$set: moleculeName},
          typedValue: {
            $set: {
              type: BaseTypedValueType.BIOENTITY,
              bioentitySummary: {id: moleculeId, name: moleculeName},
            },
          },
        },
      },
    };
  }

  return reactUpdate(structuredTable, {rows: rowsUpdateSpec});
}
